import * as tslib_1 from "tslib";
import React from 'react';
import { omit } from 'lodash';
import TextField from "../../TextFields/TextField";
import LabeledField from "../LabeledField";
import withFocusedState from "../../../enhancers/withFocusedState";

var LabeledTextField = function LabeledTextField(props) {
  return React.createElement(LabeledField, tslib_1.__assign({}, props), function (fieldProps) {
    return React.createElement(TextField, tslib_1.__assign({}, fieldProps));
  });
};

LabeledTextField.propTypes = tslib_1.__assign({}, TextField.propTypes, omit(LabeledField.propTypes, ['children']));
export default withFocusedState(LabeledTextField);

try {
  // @ts-ignore
  LabeledTextField.__docgenInfo = {
    "description": "",
    "displayName": "LabeledTextField",
    "props": {}
  };
} catch (__react_docgen_typescript_loader_error) {}